export const HtmlHelper = {
    getRoot() {
        return document.getElementById('content-admin') ?? document.body;
    },
    createContainer(containerId) {
        let container = document.getElementById(containerId);
        if (!container) {
            container = document.createElement('div');
            container.setAttribute('id', containerId);
            HtmlHelper.getRoot().appendChild(container);
        }
        return container;
    },
    isInteractive(el) {
        const interactiveSelectors = [
            'a',
            'button',
            'input',
            'label',
            '[role="link"]',
            '[role="button"]',
            '[role="checkbox"]'
        ];
        return interactiveSelectors.some((selector) => el.closest(selector));
    }
};
